<template>
  <vx-card no-shadow>
    <a-tabs default-active-key="1" @change="changeTab">
      <a-tab-pane key="1" tab="Customization">
        <h4>Brand</h4>
          <div class="w-1/2">
            <p class="font-medium">
              Display your logo or firm name in your Lexi Connect portal, Lexi Connect invitation
              form, Lexi Connect notifications, and shared via email notifications.
              about <a href="#">customizing Lexi Connect.</a>
            </p>
            <a-form-item label="Select Theme">
              <a-select class="select w-full" placeholder="Lexi (default)">
                <a-select-option value="1">
                  Lexi(default)
                </a-select-option>
                <a-select-option value="2">
                  Erfan Abedi Legal
                </a-select-option>
                <a-select-option value="3">
                  Firm name only
                </a-select-option>
                <a-select-option value="4">
                  Logo only
                </a-select-option>
                <a-select-option value="5">
                  Logo and Firm name
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item>
              <a-checkbox>
                Show the total amount due in email
              </a-checkbox>
            </a-form-item>
          </div>
          <a-divider/>
        <h4>Notifications</h4>
          <div class="w-1/2">
            <p class="font-medium">
              See what Lexi Connect and shared via email notifications look like from your
              client's perspective.
            </p>
            <a-form-item label="Choose Event">
              <a-select class="select w-full" placeholder="Shared Bill via Lexi Connect">
                <a-select-option value="1">
                  Shared Bill via Lexi Connect
                </a-select-option>
                <a-select-option value="2">
                  Shared Bill via Email
                </a-select-option>
                <a-select-option value="3">
                  Shared Calender Event
                </a-select-option>
                <a-select-option value="4">
                  Shared Message
                </a-select-option>
                <a-select-option value="5">
                  Shared Document
                </a-select-option>
                <a-select-option value="6">
                  Shared Matter
                </a-select-option>
                <a-select-option value="7">
                  Shared Outstanding Client Balance
                </a-select-option>
                <a-select-option value="8">
                  Shared Outstanding Client Balance
                </a-select-option>
                <a-select-option value="9">
                  Shared Task
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>
        <a-divider/>
        <p class="font-medium w-1/2">
          Save your changes to make them visible on Lexi Connect and shared via
          email notifications.
        </p>
        <div class="flex items-center">
          <a-button type="primary" size="large" style="border-radius: 3px !important;">
            Save Changes
          </a-button>
          <div class="pl-2">or</div>
          <a-button type="link">
            Cancel
          </a-button>
        </div>
      </a-tab-pane>
      <a-tab-pane key="2" tab="Shared Lexi Connect Resources" forceRender>
          <XTable :model="model" v-if="false"></XTable>
      </a-tab-pane>
      <a-tab-pane key="3" tab="Lexi Connect Bill Settings">
        <h4 class="font-semibold">Bill Previews</h4>
        <p>Show a preview of the client's bill right in Lexi Connect.</p>
        <a-checkbox>
          Enable Bill Preview
        </a-checkbox>
        <a-divider/>
        <div class="flex items-center">
          <vs-button type="filled" style="border-radius: 3px !important;">
            Save Lexi Connect Bill Settings
          </vs-button>
          <div class="pl-2">or</div>
          <a-button type="link">
            Cancel
          </a-button>
        </div>
      </a-tab-pane>
    </a-tabs>
  </vx-card>

</template>

<script>
  import * as TableCol from "./sharedResourceTbl";
  import XTable from "../../../../components/x-table/XTable";
    export default {
        name: "ConnectSharing",
        components:{
          XTable
        },
        data(){
          return{
            model:null,
            is_show_tbl:false
          }
        },
        methods:{
          changeTab(key){
            if(key == 1)
              this.is_show_tbl = true
            else if(key == 2)
              this.is_show_tbl = true
            else this.is_show_tbl = false
          }
        },
        watch:{
          changeTab(){
            this.is_show_tbl = false
          }
        },
        created() {
          this.model = TableCol.default
        }
    }
</script>

<style scoped>

</style>
